import { render, staticRenderFns } from "./InsightView.vue?vue&type=template&id=3bacb202&scoped=true&"
import script from "./InsightView.vue?vue&type=script&lang=js&"
export * from "./InsightView.vue?vue&type=script&lang=js&"
import style0 from "./InsightView.vue?vue&type=style&index=0&id=3bacb202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bacb202",
  null
  
)

export default component.exports